import {
  ArrowSpan,
  ButtonWrapper,
  CloseButton,
  Container,
  ContentWrapper,
  ControlButtons,
  Title,
  TitleContainer,
  TooltipWrapper,
} from './style'

import CloseIcon from 'assets/close-icon.svg?react'
import { GLOBAL_COLORS } from 'theme'
import React from 'react'
import { TooltipRenderProps } from 'react-joyride'
import Triangle from '../triangle'
import { checkPointTargets, SCROLL_TIME } from '../../provider'
import { useBoundPositioning } from '../../../../hooks/use-bounds-positioning'
import { useStore } from 'services/store'
import { useWindowSize } from 'hooks'

export const SCROLL_DELAY = SCROLL_TIME + 250

export const Tooltip: React.FC<TooltipRenderProps> = ({
  continuous,
  index,
  step,
  backProps,
  skipProps,
  primaryProps,
  tooltipProps,
}) => {
  const { isDarkMode } = useStore()
  const bubble = React.useRef<HTMLDivElement>(null)
  const { isMobile, isTablet } = useWindowSize()
  const target =
    typeof step.target === 'string' ? step.target : React.useRef<HTMLElement>(step.target)
  const { position: proposedPosition, targetInViewport } = useBoundPositioning(bubble, target)
  let position = proposedPosition
  const [loaded, setLoaded] = React.useState(false)
  const border = isDarkMode ? GLOBAL_COLORS.white : GLOBAL_COLORS.coralBlue
  const backgroundColour = isDarkMode ? GLOBAL_COLORS.black : GLOBAL_COLORS.white

  React.useEffect(() => {
    if (!targetInViewport) return
    const timer = setTimeout(() => {
      setLoaded(true)
    }, SCROLL_DELAY)

    return () => clearTimeout(timer)
  }, [targetInViewport, isMobile, isTablet])

  /**
   * Some stages of the guide the next button should be hidden
   * @returns
   */
  const shouldShowNext = () => {
    if (!continuous) return false

    switch (index) {
      case 1:
      case 8:
      case 9:
      case 11:
      case 12:
      case 16:
      case 18:
        return false
      default:
        return true
    }
  }

  const shouldShowPrev = index !== 0

  /**
   * Fix for tooltip as it comes into the screen and the triangle is not in the correct position as a result
   */
  if (step.target === '.Toastify__toast-body') {
    position = 'right-start'
  }

  return (
    <Container hide={loaded === false}>
      {loaded && !checkPointTargets.includes(step.target as string) && (
        <Triangle
          backgroundColour={backgroundColour}
          borderColour={border}
          pointing={position}
          borderThickness={2}
          step={step}
        />
      )}

      <TooltipWrapper {...tooltipProps}>
        <>
          <TitleContainer>
            {step.title && <Title>{step.title as string}</Title>}
            <CloseButton {...skipProps}>
              <CloseIcon />
            </CloseButton>
          </TitleContainer>
          <ContentWrapper ref={bubble}>{step.content as string}</ContentWrapper>
          <ButtonWrapper>
            {shouldShowPrev ? (
              <ControlButtons {...backProps} isDisabled={index === 0}>
                <ArrowSpan>←</ArrowSpan>
                <span>Prev</span>
              </ControlButtons>
            ) : (
              <div></div>
            )}
            {shouldShowNext() && (
              <ControlButtons {...primaryProps}>
                <span>Next</span>
                <ArrowSpan>→</ArrowSpan>
              </ControlButtons>
            )}
            {index === 18 && (
              <ControlButtons {...primaryProps}>
                <span>End</span>
                <ArrowSpan>→</ArrowSpan>
              </ControlButtons>
            )}
          </ButtonWrapper>
        </>
      </TooltipWrapper>
    </Container>
  )
}
